// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2l-1";
export var rateTableServiceLevelDropdown = "_2l-3";
export var rateTableTypeDropdown = "_2l-0";
export var rateTableValueModeDropdown = "_2l-2";